import {
  AdvancedMarker,
  InfoWindow,
  useAdvancedMarkerRef,
} from "@vis.gl/react-google-maps";
import { MachineInfoCard } from "components/CaseMap/MachineInfoCard";
import { MachineMarkerPin } from "components/CaseMap/MachineMarkerPin";
import { Z_INDEX } from "components/CaseMap/mapLayers";

/**
 * One machine's pin, plus its summary once the pin itself is clicked.
 *
 * Selection and the summary are deliberately separate: a sidebar row selects a
 * machine — highlighting the pin and flying to it — while only clicking the pin
 * opens the summary.
 *
 * Its own component because the marker ref the InfoWindow anchors to comes from
 * a hook, which cannot live inside the cluster layer's map callback.
 */
export function MachineMarker({
  machine,
  position,
  selected,
  summaryOpen,
  canEditStatus,
  onSelect,
  onCloseSummary,
}) {
  const [markerRef, marker] = useAdvancedMarkerRef();

  return (
    <>
      <AdvancedMarker
        ref={markerRef}
        position={position}
        title={machine.machine_id}
        zIndex={selected ? Z_INDEX.selectedMachine : Z_INDEX.machine}
        onClick={() => onSelect(machine.id)}
      >
        <MachineMarkerPin selected={selected} />
      </AdvancedMarker>
      {summaryOpen && (
        <InfoWindow
          anchor={marker}
          maxWidth={320}
          onCloseClick={onCloseSummary}
          headerDisabled
        >
          <MachineInfoCard
            machine={machine}
            canEditStatus={canEditStatus}
            position={position}
          />
        </InfoWindow>
      )}
    </>
  );
}
